import * as toastr from "toastr";
import {FileType} from "../../Models/filetype";
import {ToastType} from  "../toasttype"
import {Constants} from "../configuration/constants";
import {Modal} from "bootstrap";
interface IUtility {
    showMessage(message: string, id: string): void;
    showErrorMessage(message: string, id: string): void;
    showSuccessMessage(message: string, id: string): void;
    showDiv(id: string): void;
    hideDiv(id: string): void;
    validateEmailAddress(emailId: string): Boolean;
    toDateFormat(val: string): string;
    toDateTimeFormat(val: string): string;

    isEmpty(obj: any): Boolean;
    validateEmailAddress(emailId: string): Boolean;

    ValidateForm(formId: string): Boolean;
    closeModal(): void;
    showAlertAssignerMessageFromCookie(): void;
    removeSpaces(stringVal: string): string;
    removeExtension(filename: string): string;
    getFileExtension(filename: string): string; 
    sayToast(msg: string, toastType?: ToastType): void;
    setLocalStorage(key: string, val: string): boolean;
    getLocalStorage(key: string): any;
    removeFromLocalStorage(key: string): any;
    getCookie(cname: any): string;
    eraseCookie(name: any): void;
    setCookie(cname: any, cValue: any, days: any): void;
}
class Utility implements IUtility {
    constants: Constants;
    constructor() {
        this.constants = new Constants();
       
    }


    showMessage(message: string, id: string) {
        let divElement: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(id) as HTMLDivElement);
        if (divElement){
            divElement.innerHTML= message;
        }
        this.showDiv(id);
    }

    showErrorMessage(message: string, id: string) {
        let divElement: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(id) as HTMLDivElement);
        if (divElement){
            divElement.innerHTML= message;
            divElement.classList.add("alert","alert-error");
        }
        this.showDiv(id);
    }
    showSuccessMessage(message: string, id: string) {
        let divElement: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(id) as HTMLDivElement);
        if (divElement){
            divElement.innerHTML= message;
            divElement.classList.add("alert","alert-success");
        }
        this.showDiv(id);
    }
    showDiv(id: string): void {
        let divElement: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(id) as HTMLDivElement);
        if (divElement) {
            divElement.style.display="block";
        }
    }
    hideDiv(id: string): void {
        let divElement: HTMLDivElement | undefined = <HTMLDivElement>(document.getElementById(id) as HTMLDivElement);
        if (divElement) {
            divElement.style.display="none";
        }
    }
    validateEmailAddress(emailId: string): Boolean {
        let expr = /^[a-zA-Z0-9._]+[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
        return expr.test(emailId);
    }
    toDateFormat(val: string): string {
        try {
            // alert(val);
            //var parsedDate = new Date(parseInt(val.substr(9)));
            let parsedDate = new Date(val);
            //alert(parsedDate+parString);
            return parsedDate.getMonth() + 1 + "/" + parsedDate.getDate() + "/" + parsedDate.getFullYear();
        }
        catch (err) {
            return "";
        }
    }
    toDateTimeFormat(val: string): string {
        try {
            let parsedDate = new Date(val);
            return parsedDate.getMonth() + 1 + "-" + parsedDate.getDate() + "-" + parsedDate.getFullYear() + " " + (parsedDate.getHours() + 4) + ":" + parsedDate.getMinutes() + ":" + parsedDate.getSeconds();
        }
        catch (err) {
            return val;
        }
    }

    isEmpty(obj: any): Boolean {
        if (typeof obj === 'undefined' || obj === null || obj === '' || obj === "") return true;
        if (typeof obj === 'number' && isNaN(obj)) return true;
        if (obj instanceof Date && isNaN(Number(obj))) return true;
        let st = String(obj).trim();
        // check for the length of the string
        return st.length === 0;
    }

    setLocalStorage(key: string, val: string): boolean {
        if (localStorage) {
            localStorage.setItem(key, val);
            return true;
        } else {
            console.log("Browser do not support local storage.");
            return false;
        }
    }
    getLocalStorage(key: string): any {
        if (localStorage) {
            return localStorage.getItem(key);
        }
        return null;
    }
    removeFromLocalStorage(key: string): any {
        if (localStorage) {
            return localStorage.removeItem(key);
        }
        return null;
    }
    setCookie(cname: any, cValue: any, days: any): void {
        let d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cValue + ";" + expires + ";path=/";
    }
    eraseCookie(name: any): void {
        this.setCookie(name, "", -1);
    }
    getCookie(cname: any): string {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    ValidateForm(formId: string): Boolean {
        //console.log('ValidateForm called for:', formId);
        let form = $('#' + formId);
        //console.log('Form found:', form.length > 0);
        
        // Check if validator is available
        if (typeof $.validator === 'undefined') {
           // console.error('$.validator is not defined!');
            return false;
        }
        if (typeof $.validator.unobtrusive === 'undefined') {
           // console.error('$.validator.unobtrusive is not defined!');
            return false;
        }
        
       // console.log('Parsing form with unobtrusive validation');
        $.validator.unobtrusive.parse(form);
        
        const isValid = form.valid();
        //console.log('Form valid:', isValid);
        
        if (isValid) {
            return true;
        } 
        else {
          // console.log("Form is not valid.");
        }
        return false;
    }
    closeModal(): void {
        $("#modal").modal('hide');
        location.reload();
    }
    showAlertAssignerMessageFromCookie(): void {
        let msg = this.getCookie("AlertAssignerMessage");
        if (msg !== "") {
            alert({
                title: 'Storage type',
                message: '<p class="text-center">' + unescape(msg) + '</p>',
                backdrop: true
            });
            this.eraseCookie("AlertAssignerMessage");
        }
    }
    removeSpaces(stringVal: string): string {
        return stringVal.split(' ').join('');
    }
    removeExtension(filename: string): string {
        let lastDotPosition = filename.lastIndexOf(".");
        if (lastDotPosition === -1) return filename;
        else return filename.substr(0, lastDotPosition);
    }
    getFileExtension(filename: string): string {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
    }
    getFileIcon(filename: any): string {
        let fileTypesList: Array<FileType> = [
            new FileType('gif', 'file-image-o'),
            new FileType('jpeg', 'file-image-o'),
            new FileType('jpg', 'file-image-o'),
            new FileType('png', 'file-image-o'),
            new FileType('pdf', 'file-pdf-o'),
            new FileType('doc', 'file-word-o'),
            new FileType('docx', 'file-word-o'),
            new FileType('ppt', 'file-powerpoint-o'),
            new FileType('pptx', 'file-powerpoint-o'),
            new FileType('xls', 'file-excel-o'),
            new FileType('xlsx', 'file-excel-o'),
            new FileType('aac', 'file-audio-o'),
            new FileType('mps', 'file-audio-o'),
            new FileType('ogg', 'file-audio-o'),
            new FileType('avi', 'file-video-o'),
            new FileType('mp4', 'file-video-o'),
            new FileType('gz', 'file-zip-o'),
            new FileType('zip', 'file-zip-o'),
            new FileType('css', 'file-code-o'),
            new FileType('html', 'file-code-o'),
            new FileType('js', 'file-code-o'),
            new FileType('txt', 'file-code-o')
        ];
        let fileExtension = this.getFileExtension(filename);
        //console.log("fileExtension:" + fileExtension);
        let iconValue: string = "file-o";//default icon
        for (let i = 0; i < fileTypesList.length; i++) {
            if (fileTypesList[i].Extension === fileExtension) {
                iconValue = fileTypesList[i].Icon
            }
        }
        //console.log("iconValue:"+iconValue);
        return "<i class='glyph-icon icon-" + iconValue + " demo-icon' aria-hidden='true'></i>&nbsp;";
    }
    sayToast(msg: string, toastType?: ToastType) {
        if (toastType === ToastType.Info) {
            toastr.info(msg); 
        }
        else if (toastType === ToastType.Error) {
            toastr.error(msg);
        }
        else if (toastType === ToastType.Success) {
            toastr.success(msg);
        }
        else if (toastType === ToastType.Warning) {
            toastr.warning(msg);
        }
        else {
            toastr.info(msg);
        }
    }
}
export {Utility,IUtility}
